import { useLocation, useHistory } from 'react-router-dom';
import type { Location } from 'history';
import qs from 'query-string';

type SmidModalType = 'disconnected' | 'missing' | null;

interface UseSmidModalReturn {
  modalType: SmidModalType;
  closeModal: () => void;
}

/**
 * Hook to manage SMID education modal state and behavior based on URL parameter.
 * Supports 'smidDisconnected' and 'smidNotApplied' modal types.
 * @returns {UseSmidModalReturn} Object containing modalType and closeModal function.
 */
export const useSmidModal = (): UseSmidModalReturn => {
  const location = useLocation<Location>();
  const history = useHistory();
  
  let modalType: SmidModalType = null;
  const queryParams = qs.parse(location.search);
  const smidModalParam = queryParams.smidModal;

  const closeModal = (): void => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete('smidModal');
    history.push({
      pathname: location.pathname,
      search: searchParams.toString()
    });
  };

  if (smidModalParam === 'missing' || smidModalParam === 'disconnected') {
    modalType = smidModalParam;
  } else if (Boolean(smidModalParam)) {
    closeModal();
  }

  return { modalType, closeModal };
}; 